import { UsuarioModel } from './../models/user.model';

import { registerLocaleData } from '@angular/common';
import { ComponentFactoryResolver, Injectable , EventEmitter} from '@angular/core';
import { Router } from '@angular/router';

import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';


@Injectable({
  providedIn: 'root',
})
export class UserService {
  loggedIn = false;
  usuarioLogged;
  usuarioLoggedName;
  registroOk;
  userPisos = [];
  userRutas= [];


  constructor(private httpClient: HttpClient, private router: Router) {
    this.cargarUsusarioConectado();
  }

  register(credentials: any) {

    const params = JSON.stringify(credentials);
    //const paramsOk = params.replace(/['”]+/g, '');
    // const paramsOk = params.replace(/"/g, "'");

    const url = 'https://docentesenruta.eu-4.evennode.com/users/';
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(url, params, { headers: headers });
  }

  resetPasswordEmail(email: any) {
    let objectParams = {
      email: email,
    };
    const params = JSON.stringify(objectParams);
    const url = 'https://docentesenruta.eu-4.evennode.com/users/reset-password/';
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.httpClient.post(url, params, { headers: headers });
  }

  editUser(user) {
    if (user && user._id) {
      const params = user;
      const url = 'https://docentesenruta.eu-4.evennode.com/users/' + user._id;
      const headers = new HttpHeaders().set('Content-Type', 'application/json');
      return this.httpClient.put(url, params, { headers: headers });
    }
  }

  login(credentials: any) {
    const params = JSON.stringify(credentials);

    const url = 'https://docentesenruta.eu-4.evennode.com/users/login';
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(url, params, { headers: headers });

  }

  logout() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('usuario');
    localStorage.removeItem('token');
    this.usuarioLogged = null;
    this.loggedIn = false;
    this.router.navigate(['/login']);
    //this.currentUserSubject.next(null);
  }

  getUserName() {
    this.usuarioLoggedName = String(localStorage.getItem('usuarioName'));
    return this.usuarioLoggedName;
  }
  getUser() {
    this.usuarioLogged = JSON.parse(localStorage.getItem('usuario'));
    return this.usuarioLogged;
  }

  getUsers() {
    const url = 'https://docentesenruta.eu-4.evennode.com/users/';
    return this.httpClient.get(url);
  }
  getUserToken(token: string) {
    const url = 'https://docentesenruta.eu-4.evennode.com/users/token/' + token;
    return this.httpClient.get(url);
  }
  checkUserLogin() {
    const url = 'https://docentesenruta.eu-4.evennode.com/users/';
    return this.httpClient.get(url);
  }
  cargarUsusarioConectado() {

    if (localStorage.getItem('usuario')) {
      this.loggedIn = true;
      this.usuarioLogged = JSON.parse(localStorage.getItem('usuario'));
    }
  }
}
